/**
 * Created by stonewang on 2017/8/15.
 * zhouyanping 2021年4月15日21:00:38 update
 * 修改商品选型
 */
import React from 'react';
import {hashHistory} from 'react-router';
import '../mallApp.css';
import './product.css';
import {
    Button,
    Row,
    Col,
    Tabs,
    Radio,
    InputNumber,
    Tooltip,
    Icon,
    Modal,
    Checkbox,
    Collapse,
    message,
} from 'antd';
import moment from 'moment';
import zanWu from '../../assets/images/zanWu.png';
import {
    getProductSpecListByBenti,
    getProductSpecListByFujian,
    getProductSpecByBenti,
    getProductSpecByFujian,
    addShoppingCarList,
    getProductSpecListByBentiBelong,
    getSpecListByFujianBelong,
} from '../../service/product';
import {getFileDown} from '../../service/home';
import {commodityDetail} from '../../service/merchandise';
import {
    openNotice,
    returnFloat,
    config,
} from 'Utils';

const defaultImg = require('../../assets/images/product-default.png');
const TabPane = Tabs.TabPane;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const Panel = Collapse.Panel;
const bentiPrefix = '$radioVal@';
const fujianPrefix = '$radioVal2@';
const productLineName = {
    '01': '元器件',
    '02': '电工',
    '03': '电表',
    '04': '变频器',
    '05': '天e',
    '06': 'TG精品',
};
// 解析依赖关系
const getDepRelation = (rawList) => {
    let list = rawList.filter(x => x.belongSpecId > 0);
    let tmp = {};
    list.forEach(x => {
            let obj = rawList.filter(y => y.id === x.belongSpecId)[0] || null;
            if (obj) {
                x.productSpecParamList.forEach(y => {
                        if (y.belongParamId) {
                            let str = y.belongParamId.replace(/,/g, '|');
                            let reg = new RegExp(`^(${str})$`);
                            let arr = [];
                            obj.productSpecParamList.forEach(z => {
                                    if (reg.test(`${z.paramId}`)) {
                                        arr.push(z.propertyDesc);
                                    }
                                },
                            );
                            tmp[`${x.propertyName}‡${y.propertyDesc}`] = {
                                propertyNum: obj.propertyNum,
                                propertyName: obj.propertyName,
                                values: arr,
                            };
                        }
                    },
                );
            }
        },
    );
    return tmp;
};
// 解析被依赖关系
const getDepRelation2 = (rawList) => {
    let downList = rawList.filter(x => x.belongSpecId > 0); // 存在依赖其他规格的规格
    let parentIds = downList.map(x => x.belongSpecId); // 被依赖的规格的 ID 数组
    let parents = rawList.filter(x => parentIds.includes(x.id)).map(x => {
        let productSpecParamListMap = {};
        x.productSpecParamList.forEach(y => {
            productSpecParamListMap[`${y.paramId}`] = y
        });
        return {...x, productSpecParamListMap}
    }); // 被依赖的规格数组
    let obj = {};
    parents.forEach(x => {
        downList.forEach(y => {
            if (y.belongSpecId === x.id) {
                y.productSpecParamList.forEach(z => {
                    let belongParamIds = z.belongParamId.split(',').filter(x => !!x)
                    if (belongParamIds.length && belongParamIds.some(id => !!x.productSpecParamListMap[id])) {
                        belongParamIds.forEach(id => {
                            let key = `${x.propertyName}‡${x.productSpecParamListMap[id].propertyDesc}`
                            if (obj[key] && obj[key][y.propertyName]) {
                                obj[key][y.propertyName].push(z.propertyDesc)
                            } else {
                                obj[key] = {
                                    [y.propertyName]: [z.propertyDesc] //要显示的下级规格
                                }
                            }
                        })
                    }
                })
            }
        })
    })
    return obj
}
// 检查当前选中规格值的依赖关系
const checkDepRelation = ({
                              relationObj,
                              relationObj2,
                              specList,
                              prefix,
                              categoryId,
                              currentPropertyName,
                              currentValue
                          }) => {
    // 检查当前规格的依赖关系 ---- 上游
    let specList_copy = [...specList];
    let tmp = relationObj[`${currentPropertyName}‡${currentValue}`] || null;
    if (tmp) {
        const {propertyName, values} = tmp;
        let key = `${prefix}@${categoryId}@${propertyName}`;
        let obj = specList_copy.filter(x => x.key === key)[0] || null;
        if (obj && values.indexOf(obj.value) === -1) {
            // message.warn(`请先选择规格【${propertyName}】的值：${values.join()}`)
            openNotice('warn', `请先选择规格【${propertyName}】的值：${values.join()}`);
            return null;
        }
    }
    // 依赖当前规格的被依赖关系 ---- 下游
    let tmp2 = relationObj2[`${currentPropertyName}‡${currentValue}`] || null;
    if (tmp2) {
        Object.keys(tmp2).forEach(propertyName => {
            let index = specList_copy.findIndex(x => x.propertyName === propertyName);
            if (index > -1) {
                let o = specList_copy[index]
                if (tmp2[propertyName] && Array.isArray(tmp2[propertyName]) && tmp2[propertyName].length) {
                    let hideValue = o.propertyDescName.filter(x => !tmp2[propertyName].includes(x))
                    specList_copy.splice(index, 1, {
                        ...o,
                        value: undefined,
                        hideValue: hideValue,
                    });
                } else {
                    specList_copy.splice(index, 1, {
                        ...o,
                        value: o.value || undefined,
                        hideValue: [],
                    });
                }
            }
        })
    }
    return specList_copy;
};

class ProductDetail extends React.Component {
    constructor(props) {
        super(props);
        this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.inIframe = /^\/mallSelect/.test(props.location.pathname);
        this.id = props.params.id;
        this.productId = props.params.productId;
        this.state = {
            opts: ['产品详情'],
            selectImgIndex: 0,
            defaultActiveKey: 1,
            detailData: {},
            priceStock: {
                'price': 0,
                'suggestedPrice': 0,
                'stock': 0,
            },
            channelCode: this.channelData.split('|')[1] || '',
            options1: [],
            bentiMsg: [],     //本体
            fujianMsg: [],    //配件
            slaveSpec: [],
            specification: '',
            LogisticData: [],     //物流点选择
            inventory: '',      //库存
            customerId: this.userData.thirdId,
            inputNumber: '',  //购买数量
            add: {
                // 规格
                specifications: '',
            },
            button_limits_end: JSON.parse(window.localStorage.getItem('button_limits_end') || '{}'),
            // starClass: 'anticon-star-o' // 收藏星星样式
            isCollection: 0,
            ///////////////////////// 2020
            fujianCategoryList: [], // 配件分类列表
            fujianSet: {}, // 配件集合
            fujianCategorySpecSet: {}, // 配件分类规格集合
            collapseActiveKey: [],
            productSpecList: [],
            ///////////////////////// 2021
            bentiSpecDepRelation: {}, // 本体规格之间的依赖关系
            bentiSpecDepRelation2: {}, // 本体规格之间的被依赖关系
            fujianSpecDepRelationSet: {}, // 配件规格之间的依赖关系集合
            fujianSpecDepRelationSet2: {}, // 配件规格之间的被依赖关系集合

            mchDetail: {}, // 商品详情
            defProductDetail: {}, // 默认产品详情
            lookFileVisible: false,  // 查看附件
            lookFileUrl: null,  // 查看附件地址
        };
        this.onChangeDetailTab = this.onChangeDetailTab.bind(this);
        this.handleCancelLook = this.handleCancelLook.bind(this);
    }

    // 切换产品图片
    updateBigImg(index, qst) {
        /* 修改大图显示 */
        this.setState({selectImgIndex: index});
        this.setState({
            'detailData': {
                ...this.state.detailData,
                'bigImg': qst.fileCompressPath,
            },
        });
    }

    // 产品详情切换tab
    onChangeDetailTab(val) {
        console.log(val)
    }

    toEdit() {
        /* 跳转详情 */
        hashHistory.push('/product/add/' + this.state.detailData.id);
    };

    // 关闭查看
    handleCancelLook() {
        this.setState({lookFileVisible: false})
    }

    backHandle() {
        window.history.go(-1);
    }

    // 清空重置
    clearData() {
        sessionStorage.removeItem('_fujianCategoryList');
        sessionStorage.removeItem('_fujianSet');
        sessionStorage.removeItem('_fujianCategorySpecSet');
        sessionStorage.removeItem('_fujianSpecDepRelationSet');
        sessionStorage.removeItem('_fujianSpecDepRelationSet2');
    }

    componentWillMount() {
        // 清空
        this.clearData();
    }

    componentDidMount() {
        if (this.inIframe) {
            window.parent.window.toggleShowBackBtn(true);
            // iframe设置滚动条
            let iframe = document.getElementById('root');
            iframe.setAttribute('class', 'mall-scrollbar');
            iframe.setAttribute('name', 'my-scrollbar');
            iframe.style.border = '1px solid #dcdcdc';
            iframe.style.overflowX = 'hidden';
        }
        // 查询商品详情
        commodityDetail({id: this.id}).then((result) => {
            if (result.status) {
                let data = result.data || {};
                this.setState({
                    mchDetail: data,
                }, () => {
                    // 本体规格接口
                    this.getProductSpecList(data.proCategoryId).then(() => {
                        // 产品及本体规格选型
                        this.getProduct({id: this.productId, isInit: true}).then(() => {
                            // 获取本体规格的依赖关系
                            this.getProductSpecListByBentiBelongFn({proCategoryId: data.proCategoryId});
                        });
                    });
                    if (data.partCategoryIds) {
                        // 获取附件规格分类
                        this.getFuJianSpecList(data.partCategoryIds).then(() => {
                            // 批量获取附件信息
                            this.getFujianSet(true);
                        });
                    }
                    console.log(this.state.mchDetail)
                });
            } else {
                message.error(result.message);
            }
        });
    }

    //获取详情-默认产品信息
    getProductDetail() {
        if (this.id) {
            getProductDetails({id: this.id}).then(res => {
                if (res.status) {
                    this.setState({
                        defProductDetail: res.data,
                    });
                }
            });
        }
    }

    // 打开文件：查看，下载
    onOpenFile(type, item) {
        console.log(config.server, type, item);
        let fileUrl = getFileDown(item.id);
        if (type == "look") {
            if (!new RegExp("(jpg|png|jpeg|bmp|gif)$").test(item.extension)) {
                message.warning('目前仅支持查看图片，你可下载查看！');
                return;
            }
            this.setState({lookFileVisible: true, lookFileUrl: item.file_path});
        } else {
            window.open(`${config.server}${item.file_path.replace("getFile", "getFileDown")}`, item.fileName);
        }
    }

    downloadFileExt(filePath) {
        window.open(filePath);
    }

    componentWillUnmount() {
        if (this.inIframe) {
            window.parent.window.toggleShowBackBtn(false);
            window.parent.window.resetIframeStyle(document.getElementById('root'));
        }
        // 清空
        this.clearData();
    }

    // 获取本体规格的依赖关系
    getProductSpecListByBentiBelongFn = (data) => {
        const {productSpecList} = this.state;
        getProductSpecListByBentiBelong(data).then(res => {
            if (res.code === 200 || !!res.status) {
                let bentiSpecDepRelation = getDepRelation(res.data || []); // 依赖关系
                let bentiSpecDepRelation2 = getDepRelation2(res.data || []); // 被依赖关系
                //////////////根据被依赖关系隐藏不必显示的规格值
                let specList_copy = [...productSpecList];
                Object.keys(bentiSpecDepRelation2).forEach(key => {
                    const [name, value] = key.split('‡');
                    if (specList_copy.some(x => x.propertyName === name && x.value === value)) {
                        let tmp = bentiSpecDepRelation2[key];
                        Object.keys(tmp).forEach(propertyName => {
                            let index = specList_copy.findIndex(x => x.propertyName === propertyName);
                            if (index > -1) {
                                let o = specList_copy[index]
                                if (tmp[propertyName] && Array.isArray(tmp[propertyName]) && tmp[propertyName].length) {
                                    let hideValue = o.propertyDescName.filter(x => !tmp[propertyName].includes(x))
                                    specList_copy.splice(index, 1, {
                                        ...o,
                                        value: o.value || undefined,
                                        hideValue: hideValue,
                                    });
                                } else {
                                    specList_copy.splice(index, 1, {
                                        ...o,
                                        value: o.value || undefined,
                                        hideValue: [],
                                    });
                                }
                            }
                        })
                    }
                })
                this.setState({
                    productSpecList: specList_copy,
                    bentiSpecDepRelation, // 依赖关系
                    bentiSpecDepRelation2 // 被依赖关系
                });
            }
        });
    };

    // 本体规格接口
    getProductSpecList = (categoryId) => new Promise((resolve, reject) => {
        getProductSpecListByBenti({proCategoryId: categoryId}).then(result => {
            if (result.status && result.code == 200) {
                let list = (result.data || []).map(x => {
                    let filedName = `${bentiPrefix}${x.categoryId}@${x.propertyNum}`;
                    return {
                        ...x,
                        key: filedName, // 设置字段名称
                        value: x.propertyDescName.length > 0 ? x.propertyDescName[0] : undefined, // 设置默认值 undefined, // 用当前附件的规格值，设置字段的默认值
                        valueDef: x.propertyDescName.length > 0 ? x.propertyDescName[0] : undefined, // 设置默认值
                    };
                });
                this.setState({
                    productSpecList: list, // 本体
                }, () => {
                    resolve();
                });
            } else {
                openNotice('error', '获取本体规格失败', result.message || '');
                reject(new Error('获取本体规格失败'));
            }
        });
    });

    // 获取本体数据
    getProduct = (param) => new Promise((resolve, reject) => {
        const self = this;
        const isInit = !!param.isInit;
        const {productSpecList, detailData, mchDetail} = this.state;
        getProductSpecByBenti(param).then(res => {
            if (res.code === 200) {
                let data = res.data || {};
                let priceStock = {};
                data.count = 1;
                // 如果产品没有图片，就展示商品的图片
                data.picUrls = data.picUrls && data.picUrls.length ? data.picUrls : mchDetail.picMainList;
                data.picUrls = (data.picUrls || []).map(x => ({
                    ...x,
                    filePath: x.file_path || x.filePath,
                    fileCompressPath: x.fileCompressPath || x.file_compress_path,
                }));
                data.bigImg = data.picUrls && data.picUrls.length > 0 ? data.picUrls[0].filePath : '';
                if (!!data.id) {
                    priceStock = {
                        price: data.showPrice || '',
                        suggestedPrice: data.suggestedPrice || '',
                        stock: `${(data.inventory || 0)} ${data.unitText}`,
                    };
                }
                if (!data.id) {
                    data.name =
                        <span>{res.message ? res.message.replace(/(，|\,)(建议提交产品定制|是否提交定制订单)/, '') : '未匹配到相应的商品'}<span
                            className="dms-red">，建议提交产品定制</span></span>;
                    data.itemNum = '';
                    data.unit = '';
                    data.minPackageQuantity = '';
                    data.packageQuantity = '';
                    data.sortOrder = '';
                    data.stockType = '';
                    data.minOrderQuantity = '';
                    data.price = 0;
                    data.count = 0;
                    data = {
                        ...data,
                        proBigType: detailData.proBigType,
                        proMiddleType: detailData.proMiddleType,
                        proDetailType: detailData.proDetailType,
                        proBigName: detailData.proBigName,
                        proMiddleName: detailData.proMiddleName,
                        proDetailName: detailData.proDetailName,
                        proLine: detailData.proLine,
                    };
                    let session_key = `customOrder@benti@${self.state.detailData.categoryId}`;
                    window.sessionStorage.setItem(session_key, JSON.stringify(param));
                    data.notFoundMsg = res.message;
                    data.session_key = session_key;
                    // 去掉切换规格提升
                    // openNotice('info', res.message);
                    // this.openModal('goAway', session_key);
                }
                let currentSpecValues = {}; // 当前本体的规格值集合
                if (data.categoryTypeVo && data.categoryTypeVo.bentiMsg && data.categoryTypeVo.bentiMsg.length) {
                    data.categoryTypeVo.bentiMsg.filter(x => !!x).forEach(x => {
                        currentSpecValues[`${bentiPrefix}${x.categoryId}@${x.propertyName}`] = x.propertyDesc;
                    });
                }
                let newMainSpec = productSpecList.map(x => {
                    let filedName = `${bentiPrefix}${x.categoryId}@${x.propertyName}`;
                    return {
                        ...x,
                        key: filedName, // 设置字段名称
                        defaultValue: isInit ? currentSpecValues[filedName] : x.defaultValue,
                        value: currentSpecValues[filedName], // 用当前附件的规格值，设置字段的默认值
                    };
                });
                self.setState({
                    detailData: data,
                    isCollection: data.isCollection, /* 是否收藏 0未收藏 1已收藏 */
                    hasDetail: true,
                    productSpecList: newMainSpec,
                    priceStock,
                }, () => {
                    resolve(data);
                });
            } else {
                openNotice('error', '获取本体失败', res.message || '');
                reject(new Error('获取本体失败'));
            }
        });
    });

    // 本体规格切换
    bentiSpecChange = (value, name) => {
        // const value = e.target.value;
        const {productSpecList, bentiSpecDepRelation, bentiSpecDepRelation2} = this.state;
        const [prefix, categoryId, propertyName] = name.split('@');
        console.log('debug prefix, categoryId, propertyNum: ', prefix, categoryId, propertyName);
        console.log('debug bentiSpecDepRelation', bentiSpecDepRelation);
        let productSpecList_copy = checkDepRelation({
            relationObj: bentiSpecDepRelation, // 依赖关系
            relationObj2: bentiSpecDepRelation2, // 被依赖关系
            specList: productSpecList,
            prefix,
            categoryId,
            currentPropertyName: propertyName,
            currentValue: value,
        });
        if (!productSpecList_copy) {
            return;
        }

        // 切换设置默认值
        let resetList = productSpecList_copy.map(function (s) {
            let vs = s.propertyDescName; // 初始值
            let hs = s.hideValue; // 隐藏值
            // 新值
            let ns = vs;
            if (hs && hs.length > 0) {
                ns = vs.filter((v, index, arr) => {
                    return hs.indexOf(v) < 0;
                })
            }
            // 判断默认值是否存在，存在则取，不存在设置默认值，没有则重置。
            if (ns.length > 0) {
                s.valueDef = ns[s.defaultValue] ? s.defaultValue : ns[0];
            } else {
                s.valueDef = '';
            }
            s.value = s.value ? s.value : s.valueDef;
            return s;
        })
        console.log('resetList====', resetList)

        let list = productSpecList_copy.map(x => ({
            ...x,
            categoryId: x.categoryId,
            propertyName: x.propertyName,
            value: x.propertyName === propertyName ? value : x.value,
        }));
        let bentiMsg = list.filter(x => !!x.value).map(x => ({
            categoryId: x.categoryId,
            propertyName: x.propertyName,
            propertyNum: x.propertyNum,
            propertyDesc: x.value,
        }));
        // 创建一个新数组，精简接口参数
        // let specValue = list.filter(x => !!x.value).map(x => `${x.propertyName}&${x.value}`).sort((a, b) => a.localeCompare(b, 'zh-CN')).join('@');
        let specValue = list.filter(x => !!x.value).map(x => `${x.propertyName}&${x.value}`).join('@');

        let propNams = list.filter(x => !!x.value);

        console.log('=====前端排序====：', specValue, list)
        this.getProduct({categoryId, specValue, propertyCategoryCode: '本体'}).then((data) => {
            if (!data.id && data.session_key) {
                window.sessionStorage.setItem(data.session_key, JSON.stringify({
                    categoryId,
                    bentiMsg,
                    notFoundMsg: data.notFoundMsg || '未匹配到相应的商品，建议提交产品定制',
                }));
            }
            // 查询成功，则更新页面
            this.setState({
                productSpecList: list,
            });
        }).catch((e) => {
            openNotice('error', '获取产品失败', e.message || '');
        });
    };

    // 获取附件规格分类
    getFuJianSpecList = (categoryIds) => new Promise((resolve, reject) => {
        getProductSpecListByFujian({partCategoryIds: categoryIds}).then(result => {
            if (result.status && result.code == 200) {
                let obj = {};
                (result.data || []).filter(x => !!x.categoryId).forEach(x => {
                    obj[x.categoryId] = null;
                });

                let fjl = (result.data || []).filter(x => !!x.categoryId).map(x => ({...x, checked: false}));
                // console.log('======getProductSpecListByFujian==========')
                // console.log('配件分类列表：',fjl)
                // console.log('配件集合',obj)

                sessionStorage.setItem('_fujianCategoryList', JSON.stringify(fjl))
                sessionStorage.setItem('_fujianSet', JSON.stringify(obj))

                this.setState({
                    fujianCategoryList: fjl, // 配件分类列表
                    fujianSet: obj, // 配件集合
                }, () => {
                    resolve();
                });
            } else {
                openNotice('error', '获取配件规格失败', result.message || '');
                reject(new Error('获取配件规格失败'));
            }
        });
    });

    // 批量获取附件信息
    getFujianSet = (isInit) => {
        const self = this;
        const {fujianCategoryList} = this.state;
        // console.log('=====getFujianSet======')
        // console.log('fujianCategoryList：',fujianCategoryList)
        const promises = fujianCategoryList.map(function (x, index) {
            return new Promise((resolve, reject) => {
                window.setTimeout(() => {
                    // console.log('===循环获取附件信息：',{ partCategoryId: x.categoryId, isInit: !!isInit })
                    // 获取附件信息
                    self.getFuJianByCategoryInfo({partCategoryId: x.categoryId, isInit: !!isInit}).then(() => {
                        resolve();
                    });
                }, index * 120);
            });
        });
        Promise.all(promises).then(function (posts) {
            console.log('获取配件集合成功');
            self.setState({
                fujianCategoryList: JSON.parse(sessionStorage.getItem("_fujianCategoryList")),
                fujianSet: JSON.parse(sessionStorage.getItem("_fujianSet")),
                fujianCategorySpecSet: JSON.parse(sessionStorage.getItem("_fujianCategorySpecSet")),
            })
            const promises2 = fujianCategoryList.map(function (x, index) {
                return new Promise((resolve, reject) => {
                    window.setTimeout(() => {
                        // console.log('====getSpecListByFujianBelongFn===',{ categoryId: x.categoryId });
                        // 附件规格从属关系
                        self.getSpecListByFujianBelongFn({categoryId: x.categoryId}).then(() => {
                            resolve(true);
                        });
                    }, index * 120);
                });
            });

            Promise.all(promises2).then(function (res) {
                console.log('全部加载完成: ', res)
                self.setState({
                    fujianCategoryList: JSON.parse(sessionStorage.getItem("_fujianCategoryList")),
                    fujianSet: JSON.parse(sessionStorage.getItem("_fujianSet")),
                    fujianCategorySpecSet: JSON.parse(sessionStorage.getItem("_fujianCategorySpecSet")),
                })
            }).catch(function (err) {
                console.log('全部加载失败', err);
            });
            /*.then(function (posts) {
              console.log('获取配件规格之间的依赖关系集合成功');
            }).catch(function (reason) {
              console.log('获取配件规格之间的依赖关系集合失败');
            });*/
        }).catch(function (reason) {
            console.log('获取配件集合失败');
        });
    };
    // 附件规格从属关系
    getSpecListByFujianBelongFn = (param) => new Promise((resolve, reject) => {
        getSpecListByFujianBelong(param).then(res => {
            if (res.code === 200 || res.status) {
                let fujianSpecDepRelation = getDepRelation(res.data || []); // 依赖关系
                let fujianSpecDepRelation2 = getDepRelation2(res.data || []); // 被依赖关系
                //////////////根据被依赖关系隐藏不必显示的规格值
                let fjSpec = this.state.fujianCategorySpecSet[param.categoryId];
                // console.log(this.state.fujianCategorySpecSet,'--------开始计算从属关系====',param.categoryId,fjSpec)
                let specList_copy = fjSpec ? [...fjSpec] : [];
                Object.keys(fujianSpecDepRelation2).forEach(key => {
                    const [name, value] = key.split('‡');
                    if (specList_copy.some(x => x.propertyName === name && x.value === value)) {
                        let tmp = fujianSpecDepRelation2[key];
                        Object.keys(tmp).forEach(propertyName => {
                            let index = specList_copy.findIndex(x => x.propertyName === propertyName);
                            if (index > -1) {
                                let o = specList_copy[index]
                                if (tmp[propertyName] && Array.isArray(tmp[propertyName]) && tmp[propertyName].length) {
                                    let hideValue = o.propertyDescName.filter(x => !tmp[propertyName].includes(x))
                                    specList_copy.splice(index, 1, {
                                        ...o,
                                        value: undefined,
                                        hideValue: hideValue,
                                    });
                                } else {
                                    specList_copy.splice(index, 1, {
                                        ...o,
                                        value: o.value || undefined,
                                        hideValue: [],
                                    });
                                }
                            }
                        })
                    }
                })

                // console.log('--------开始计算从属关系==显示==',specList_copy)
                // console.log('--------开始计算从属关系==依赖关系==',fujianSpecDepRelation)
                // console.log('--------开始计算从属关系==被依赖关系==',fujianSpecDepRelation2)

                /**循环请求构建规格，因setState内部存在合并机制，导致数据错乱，时有时无，采用本地存储处理。 */

                    // 本地存储fujianCategorySpecSet
                let fjs1 = JSON.parse(sessionStorage.getItem('_fujianCategorySpecSet')) || this.state.fujianCategorySpecSet;
                fjs1 = {
                    ...fjs1,
                    [param.categoryId]: specList_copy,
                }
                sessionStorage.setItem('_fujianCategorySpecSet', JSON.stringify(fjs1));
                // 本地存储fujianSpecDepRelationSet
                let fjs2 = JSON.parse(sessionStorage.getItem('_fujianSpecDepRelationSet')) || this.state.fujianSpecDepRelationSet;
                fjs2 = {
                    ...fjs2,
                    [param.categoryId]: fujianSpecDepRelation,
                }
                sessionStorage.setItem('_fujianSpecDepRelationSet', JSON.stringify(fjs2));
                // 本地存储fujianSpecDepRelationSet2
                let fjs3 = JSON.parse(sessionStorage.getItem('_fujianSpecDepRelationSet2')) || this.state.fujianSpecDepRelationSet2;
                fjs3 = {
                    ...fjs3,
                    [param.categoryId]: fujianSpecDepRelation2,
                }
                sessionStorage.setItem('_fujianSpecDepRelationSet2', JSON.stringify(fjs3));

                this.setState({
                    fujianCategorySpecSet: {
                        ...this.state.fujianCategorySpecSet,
                        [param.categoryId]: specList_copy,
                    },
                    fujianSpecDepRelationSet: {
                        ...this.state.fujianSpecDepRelationSet,
                        [param.categoryId]: fujianSpecDepRelation,
                    },
                    fujianSpecDepRelationSet2: {
                        ...this.state.fujianSpecDepRelationSet2,
                        [param.categoryId]: fujianSpecDepRelation2,
                    },
                });
                resolve(true);
            }
        });
    });

    // 获取附件信息
    getFuJianByCategoryInfo = (param) => new Promise((resolve, reject) => {
        const {fujianCategorySpecSet, fujianSet} = this.state;
        const isInit = !!param.isInit; // 是否为页面初始化
        const categoryId = param.partCategoryId || param.categoryId;
        getProductSpecByFujian(param).then(res => {
            if (res.code == 200) {
                let data = res.data || {};
                let oldFujian = fujianSet[categoryId];
                if (!data.id && !!fujianSet[categoryId]) {
                    console.log('用户选择的规格没有查到附件');
                    let session_key = `customOrder@fujian@${categoryId}`;
                    window.sessionStorage.setItem(session_key, JSON.stringify({...param}));
                    data.session_key = session_key;
                    // data.name = <span>未匹配到相应的附件<span className="dms-red">，建议提交产品定制</span></span>
                    data.notFoundMsg = res.message ? res.message.replace(/(，|\,)(建议提交产品定制|是否提交定制订单)/, '，请选择其他附件').replace(/商品/g, '附件') : '未匹配到相应的附件，请选择其他附件';
                    data.name =
                        <span>{res.message ? res.message.replace(/(，|\,)(建议提交产品定制|是否提交定制订单)/, '').replace(/商品/g, '附件') : '未匹配到相应的附件'}<span
                            className="dms-red">，请选择其他附件</span></span>;
                    // this.openModal('goAway', session_key);
                    // openNotice('info', data.notFoundMsg); 去掉附件提醒
                }
                data.count = 0; // 设置购买数量
                let currentSpecValues = {}; // 当前附件的规格值集合
                // 当前附件的分类规格清单
                let currentCategorySpecList = fujianCategorySpecSet[categoryId] ? [...fujianCategorySpecSet[categoryId]] : [];
                //获取当前配件的规格值
                if (data.categoryTypeVo && data.categoryTypeVo.fujianMsg) {
                    data.categoryTypeVo.fujianMsg.filter(x => !!x).forEach(x => {
                        currentSpecValues[`${fujianPrefix}${x.categoryId}@${x.propertyName}`] = x.propertyDesc;
                    });
                }
                /**处理当前附件的规格清单
                 * 如果接口返回了规格清单，使用返回的数据。否则，使用state中的数据
                 * */
                if (data.itemCategory && data.itemCategory.fujianMsg && data.itemCategory.fujianMsg.length) {
                    currentCategorySpecList = data.itemCategory.fujianMsg.filter(x => !!x).map(x => {
                        let filedName = `${fujianPrefix}${x.categoryId}@${x.propertyName}`;
                        return {
                            ...x,
                            key: filedName, // 设置字段名称
                            defaultValue: isInit ? currentSpecValues[filedName] : x.defaultValue,
                            value: currentSpecValues[filedName], // 用当前附件的规格值，设置字段的默认值
                        };
                    });
                } else {
                    currentCategorySpecList = currentCategorySpecList.filter(x => !!x).map(x => {
                        let filedName = `${fujianPrefix}${x.categoryId}@${x.propertyName}`;
                        return {
                            ...x,
                            key: filedName, // 设置字段名称
                            defaultValue: isInit ? currentSpecValues[filedName] : x.defaultValue,
                            value: currentSpecValues[filedName], // 用当前附件的规格值，设置字段的默认值
                        };
                    });
                }
                if (!data.id) {
                    if (isInit) {
                        // 如果接口返回数据中不包含关键信息，则界面不展示附件
                        data = null;
                        currentCategorySpecList = [];
                    } else {
                        // 用户选择的规格没有查到附件
                        data = {
                            ...data,
                            proBigType: oldFujian.proBigType,
                            proMiddleType: oldFujian.proMiddleType,
                            proDetailType: oldFujian.proDetailType,
                            proBigName: oldFujian.proBigName,
                            proMiddleName: oldFujian.proMiddleName,
                            proDetailName: oldFujian.proDetailName,
                            proLine: oldFujian.proLine,
                        };
                    }
                }
                // console.log('==fujianSet==追加：',data)
                // console.log('==fujianCategorySpecSet==追加：',categoryId, fujianCategorySpecSet, currentCategorySpecList)

                // 本地存储fujianSet
                let fjs1 = JSON.parse(sessionStorage.getItem('_fujianSet')) || fujianSet;
                fjs1 = {
                    ...fjs1,
                    [categoryId]: data,
                }
                sessionStorage.setItem('_fujianSet', JSON.stringify(fjs1));
                // 本地存储fujianCategorySpecSet
                let fjs2 = JSON.parse(sessionStorage.getItem('_fujianCategorySpecSet')) || fujianCategorySpecSet;
                fjs2 = {
                    ...fjs2,
                    [categoryId]: currentCategorySpecList,
                }
                sessionStorage.setItem('_fujianCategorySpecSet', JSON.stringify(fjs2));

                this.setState({
                    fujianSet: {
                        ...fujianSet,
                        [categoryId]: data,
                    },
                    fujianCategorySpecSet: {
                        ...fujianCategorySpecSet,
                        [categoryId]: currentCategorySpecList,
                    },
                }, () => {
                    resolve(data);
                });
            } else {
                reject(new Error('获取配件失败'));
            }
        });
    });

    // 附件选中
    onCheckfujian = (checked, index) => {
        const {fujianCategoryList, fujianSet} = this.state;
        const categoryId = fujianCategoryList[index].categoryId;
        const fujian = fujianSet[categoryId];
        if (checked) {
            if (fujian.minPackageFlag === 'Y' && !!fujian.minPackageQuantity) {
                fujian.count = fujian.minPackageQuantity;
            } else {
                fujian.count = 1;
            }
        } else {
            fujian.count = 0;
        }
        fujianCategoryList.splice(index, 1, {...fujianCategoryList[index], checked: checked});
        this.setState({
            fujianCategoryList,
            fujianSet: {
                ...fujianSet,
                [categoryId]: fujian,
            },
            // fujianCategorySpecSet: {
            //   ...fujianCategorySpecSet,
            //   [categoryId]: fujian,
            // },
        });
    };

    // 附件规格切换
    fujianSpecChange = (value, name) => {
        const {fujianCategorySpecSet, fujianSpecDepRelationSet, fujianSpecDepRelationSet2} = this.state;
        const [prefix, categoryId, propertyName] = name.split('@');
        const fujianSpecDepRelation = fujianSpecDepRelationSet[categoryId] || {}; // 依赖关系
        const fujianSpecDepRelation2 = fujianSpecDepRelationSet2[categoryId] || {}; // 被依赖关系
        console.log('debug prefix, categoryId, propertyNum: ', prefix, categoryId, propertyName);
        let fujianCategorySpecList = (fujianCategorySpecSet[categoryId] || []).map(x => ({
            ...x,
            categoryId: x.categoryId,
            propertyName: x.propertyName,
            value: x.propertyName === propertyName ? value : x.value,
        })); // 创建一个新数组，使其不影响state中的数据
        fujianCategorySpecList = checkDepRelation({
            relationObj: fujianSpecDepRelation,
            relationObj2: fujianSpecDepRelation2,
            specList: fujianCategorySpecList,
            prefix,
            categoryId,
            currentPropertyName: propertyName,
            currentValue: value,
        });
        if (!fujianCategorySpecList) {
            return;
        }
        let fujianMsg = fujianCategorySpecList.filter(x => !!x.value).map(x => ({
            id: x.id,
            categoryId: x.categoryId,
            propertyName: x.propertyName,
            propertyNum: x.propertyNum,
            propertyDesc: x.value,
        })); // 创建一个新数组，精简接口参数
        // let specValue = fujianCategorySpecList.filter(x => !!x.value).map(x => `${x.propertyName}&${x.value}`).sort((a, b) => a.localeCompare(b, 'zh-CN')).join('@'); // 创建一个新数组，精简接口参数
        let specValue = fujianCategorySpecList.filter(x => !!x.value).map(x => `${x.propertyName}&${x.value}`).join('@');
        console.log('前端排序：', specValue)
        this.getFuJianByCategoryInfo({categoryId, specValue, propertyCategoryCode: '附件'}).then((data) => {
            // 查询成功，则更新页面
            if (!data.id && data.session_key) {
                window.sessionStorage.setItem(data.session_key, JSON.stringify({
                    categoryId,
                    fujianMsg,
                    notFoundMsg: data.notFoundMsg,
                }));
            }
            this.setState({
                fujianCategorySpecSet: {
                    ...fujianCategorySpecSet,
                    [categoryId]: fujianCategorySpecList,
                },
            });
        }).catch((e) => {
            openNotice('error', '获取配件失败', e.message || '');
        });
    };

    // 附件购买数量改变
    fujianBuyNumchange = (categoryId, val) => {
        const {fujianSet} = this.state;
        this.setState({
            fujianSet: {
                ...this.state.fujianSet,
                [categoryId]: {...fujianSet[categoryId], count: val},
            },
        });
    };

    // 打开弹框
    openModal = (opt, session_key) => {
        if (this.userData.second && !!session_key) {
            Modal.warning({
                title: '请联系上级经销商',
            });
            return;
        }
        if (opt === 'goAway' && !!session_key) {
            this.session_key = session_key;
        }
        // this.setState({ opt, visible: true });

        // 不弹窗，直接购买
        this.setState({opt, visible: false});
        this.closeModal(opt);
    };

    // 关闭弹框
    closeModal = (opt) => {
        // this.userData.second
        this.setState({visible: false});
        switch (opt) {
            case 'addCart':
                this.addShoppingCarListFn();
                break;
            case 'buy':
                this.buyHandle();
                break;
            case 'add':
                this.buyHandle();
                break;
            case 'goAway':
                this.submitCustome();
                break;
            default:
                this.setState({visible: false});
        }
    };

    // 立即购买，二级渠道购买时则走结算页面，非二级渠道去生成订单页面。
    buyHandle = (justFujian, categoryId) => {
        const {fujianCategoryList, detailData, fujianSet} = this.state;
        let list = [];
        if (!!justFujian && !!categoryId) { // 单独购买附件
            list = [categoryId].map(x => fujianSet[x]);
        } else {
            list = fujianCategoryList.filter(x => x.checked).map(x => fujianSet[x.categoryId]);
            list.unshift(detailData);
        }
        for (let i = 0; i < list.length; i++) {
            if (!list[i].count) {
                openNotice('warning', `请设置「${list[i].name}」的购买数量。`);
                return;
            }
            if (list[i].minPackageFlag === 'Y' && (list[i].count % list[i].minPackageQuantity)) {
                openNotice('warning', '购买数量必须是最小起订量的整数倍!');
                return;
            }
        }
        if (this.inIframe) {
            list.forEach(x => {
                window.parent.window.addProduct({
                    id: x.id,
                    name: x.name, // 在后续页面被赋值给 productName
                    productId: x.id,
                    itemNum: x.itemNum || '',
                    proLine: x.proLine,
                    productionCycle: x.productionCycle,
                    originalPrice: x.originalPrice || x.showPrice,
                    showPrice: x.showPrice,
                    count: x.count || 1,
                    packageQuantity: x.packageQuantity,
                    minPackageQuantity: x.minPackageQuantity,
                    delvId: null, // 在后续页面赋值
                    stockType: x.stockType,
                    unit: x.unit,
                    totalAmount: x.showPrice * x.count,
                });
            });
            hashHistory.go(-1);
            return;
        }
        if (this.userData.second) {
            //结算页面
            // 精简字段
            list = list.map(x => {
                let unitPrice = Math.ceil((x.showPrice || x.originalPrice) * (100 - (x.priceRate || 0))) * 0.01;
                return {
                    name: x.name, // 在后续页面被赋值给 productName
                    code: x.itemNum || '', // 物料编码
                    picUrl: x.picUrl,
                    productId: x.id,
                    priceRate: x.priceRate || 0, // 下浮率
                    unitPrice: unitPrice, // 实际单价，下浮价
                    originalPrice: x.originalPrice,
                    currentPrice: x.showPrice,
                    unit: x.unit,
                    count: x.count,
                    remark: x.remark || null,
                    productType: 2, //
                    sumPrice: unitPrice * x.count,
                };
            });
            window.sessionStorage.setItem('list_orders', JSON.stringify(list));
            hashHistory.push('/mallPay');
        } else {
            // 去生成订单页面
            // 精简字段
            list = list.map(x => ({
                name: x.name, // 在后续页面被赋值给 productName
                productId: x.id,
                itemNum: x.itemNum || '',
                proLine: x.proLine,
                productionCycle: x.productionCycle,
                originalPrice: x.originalPrice || x.showPrice,
                showPrice: x.showPrice,
                count: x.count,
                packageQuantity: x.packageQuantity,
                minPackageQuantity: x.minPackageQuantity,
                delvId: null, // 在后续页面赋值
                stockType: x.stockType,
                unit: x.unit,
                totalAmount: x.showPrice * x.count,
            }));
            window.sessionStorage.setItem('list_orders', JSON.stringify(list));
            hashHistory.push('/shoppingCar/add/4');
        }
    };

    // 加入购物车
    // 参数：[{"productId":"16030588","channelCode":"DL","count":1}]
    addShoppingCarListFn = () => {
        const {detailData, channelCode} = this.state;
        if (detailData.id) { //
            addShoppingCarList([
                {
                    productId: detailData.id,
                    channelCode: channelCode,
                    commodityId: this.id,
                    count: detailData.count,
                },
            ]).then(res => {
                res.status && openNotice('success', '添加购物车成功', res.message || '');
                !res.status && openNotice('error', '添加购物车失败', res.message || '');
            });
        }
    };

    // 提交定制订单
    submitCustome = () => {
        // if(this.userData.roleCode === 'TG_CUSTOMER') {}
        if (!!this.session_key) {
            const {fujianCategorySpecSet, fujianSet, productSpecList, detailData} = this.state;
            const [prifix, type, categoryId] = this.session_key.split('@');
            const selectedSpec = JSON.parse(window.sessionStorage.getItem(this.session_key));
            let data = type === 'fujian' ? fujianSet[categoryId] : detailData;
            let fujianSpec = type === 'fujian' ? selectedSpec.fujianMsg || [] : [];
            let bentiSpec = type === 'benti' ? selectedSpec.bentiMsg || [] : [];
            const {
                proBigType, proMiddleType, proDetailType,
                proBigName, proMiddleName, proDetailName,
            } = data;
            let sessionData = {
                thirdId: `${this.userData.thirdId}`,
                fujianSpec,
                bentiSpec,
                categoryId: categoryId,
                proLine: data.proLine,
                proBigType, proMiddleType, proDetailType,
                proBigName, proMiddleName, proDetailName,
            };
            window.sessionStorage.setItem(this.session_key, JSON.stringify(sessionData));
            if (this.inIframe) {
                window.parent.location.href = `${window.parent.location.href.split('#')[0]}#/customOrder/add?session_key=${this.session_key}`;
            } else {
                hashHistory.push(`/customOrder/add?session_key=${this.session_key}`);
            }
        }
    };

    render() {
        const self = this;
        const {
            detailData, defProductDetail, mchDetail, selectImgIndex, priceStock, visible, opt,
            productSpecList, // 配件分类规格
            fujianCategorySpecSet, // 配件分类规格集合
            fujianCategoryList, // 配件分类列表
            fujianSet, // 配件集合
            collapseActiveKey,
        } = this.state;
        const customOrderInfo = JSON.parse(window.sessionStorage.getItem(this.session_key) || '{}').notFoundMsg;
        const okText = {
            buy: '立即购买',
            addCart: '加入购物车',
            add: '添加',
        };
        const modalProps = {
            visible,
            width: 800,
            title: opt === 'goAway' ? '当前商品不存在，是否提交定制订单' : detailData.name,
            onCancel: () => this.setState({visible: false}),
            footer: [
                (opt !== 'goAway') && <Button key="0"
                                              type="primary"
                                              icon={opt === 'add' ? 'plus' : null}
                                              onClick={() => this.closeModal(opt)}>{okText[opt]}</Button>,
                (opt === 'goAway') && <Button key="1" onClick={() => this.closeModal(opt)}>提交定制</Button>,
            ].filter(x => !!x),
        };
        const content = (
            <div style={{width: 320}}>
                <Row>
                    <Col span={12}>
                        <label>日期</label>
                    </Col>
                    <Col span={12}>
                        <label>价格</label>
                    </Col>
                    <Col span={12} style={{marginTop: 6}}>
                        <label>{moment(detailData.createdDate).format('YYYY-MM-DD HH:mm:ss')}</label>
                    </Col>
                    <Col span={12} style={{marginTop: 6}}>
                        <label>¥{priceStock.price}</label>
                    </Col>
                </Row>
            </div>
        );
        const boxHeight = 682;
        const radioLayout = {marginLeft: 10};
        const radioButtonLayout = {marginRight: 10, marginBottom: 10};
        const specBoxStyle = {
            padding: '12px',
            background: '#fff',
            height: boxHeight - 41,
            overflow: 'scroll',
            borderBottom: '1px solid #dcdcdc'
        };
        const specRender = (list, changeHandle) => (list).map((ele, index, arr) => {
            var radioOptionsRenderer = (ele.propertyDescName || []).map((e, i) => {
                let _className = '';
                if (arr.length) {
                    for (let i = 0; i < arr.length; i++) {
                        if (ele.propertyName == arr[i].propertyName) {
                            let _str = ',' + arr[i].propertyDescName + ',';
                            _className = _str.indexOf(',' + e + ',') != -1 ? '' : 'grayBtn';
                            break;
                        }
                    }
                }
                if (Array.isArray(ele.hideValue) && ele.hideValue.length && ele.hideValue.includes(e)) {
                    return null;
                }
                return <RadioButton
                    style={radioButtonLayout}
                    key={i}
                    value={e}
                    className={_className}
                >{e}
                </RadioButton>;
            }).filter(x => !!x);
            return (
                <div className="dms-spec-radio-group" key={index}>
                    {(index > 0) && <div className="dms-split-bar"/>}
                    <div style={{fontWeight: 'bold', marginBottom: '10px'}}>
                        <Icon type="logout" style={{paddingLeft: '1px'}}/>&emsp;{ele.propertyName}
                    </div>
                    {/* <div>{JSON.stringify(ele)}</div> */}
                    <RadioGroup
                        name={ele.key}
                        value={ele.value ? ele.value : ele.valueDef}
                        style={radioLayout}
                        onChange={(e) => changeHandle(e.target.value, ele.key)}>
                        {radioOptionsRenderer}
                        {/* &emsp;{!!radioOptionsRenderer.length && <span onClick={() => changeHandle(undefined, ele.key)}><Icon type="close-circle-o" /></span>} */}
                    </RadioGroup>
                </div>
            );
        });
        // tab_individual my-ant-tabs
        const specToggleArea = () => <Tabs className="product-detail-tabs">
            <TabPane tab="本体" key="1">
                <div style={specBoxStyle} className="mall-scrollbar">
                    {specRender(productSpecList || [], this.bentiSpecChange)}
                </div>
            </TabPane>
            <TabPane tab="附件" key="2">
                <div style={specBoxStyle} className="mall-scrollbar">
                    <Collapse
                        bordered={false}
                        activeKey={collapseActiveKey}
                        onChange={(key) => this.setState({collapseActiveKey: key})}>
                        {
                            fujianCategoryList.map((x, index) => {
                                const fujian = fujianSet[x.categoryId];
                                if (!fujian) return null;
                                return <Panel
                                    className="custom-panel"
                                    header={<div className="fujian-panel-head">
                        <span className="check-box">
                          <Checkbox
                              onChange={(e) => {
                                  e.stopPropagation();
                                  this.onCheckfujian(e.target.checked, index);
                              }}
                              checked={x.checked}/>
                        </span>
                                        {x.categoryName}
                                    </div>}
                                    key={`${index}_${x.categoryId}`}>
                                    <Row type="flex" justify="start">
                                        <Col span={4} className="fujian-img-box">
                                            <img
                                                className='cart-img'
                                                src={!!fujian.picUrl ? `${config.server}${fujian.picUrl}` : defaultImg}
                                                onError={e => e.target.src = defaultImg}
                                                alt=""/>
                                        </Col>
                                        <Col span={20}>
                                            <Row type="flex" justify="space-between"
                                                 style={{flexDirection: 'column', height: '100%'}}>
                                                <Col span={24}>{fujian.name}</Col>
                                                <Col span={24}><span
                                                    className="dms-red">¥ {fujian.showPrice}</span></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <div className="dms-split-bar"/>
                                    {/*<Row className="mb-10">*/}
                                    {/*  <b>附件名称：</b>{fujian.name}*/}
                                    {/*</Row>*/}
                                    <Row className="mb-10">
                                        <b>数量：&emsp;&emsp;</b><InputNumber
                                        min={0}
                                        step={fujian.minPackageFlag === 'Y' && fujian.minPackageQuantity ? fujian.minPackageQuantity : 1}
                                        value={fujian.count}
                                        style={{width: 100}}
                                        onChange={(val) => this.fujianBuyNumchange(x.categoryId, val)}/>
                                    </Row>
                                    {/*<Row className="mb-10">
                   <b>配用壳架：</b>{fujian.name}
                   </Row>*/}
                                    <Row className="mb-10">
                                        <b>规格信息：</b>
                                    </Row>
                                    {/*<div className="pl-2em">*/}
                                    <div>
                                        {specRender(fujianCategorySpecSet[x.categoryId] || [], this.fujianSpecChange)}
                                    </div>
                                    <div className="dms-split-bar"></div>
                                    {!!fujian.id &&
                                        <Button type="primary" size="large"
                                                onClick={() => this.buyHandle(true, x.categoryId)}>单独购买</Button>}
                                    {/*&emsp;&emsp;&emsp;*/}
                                    {/*{!fujian.id && <Button onClick={this.openModal.bind(this, 'goAway', fujian.session_key)}>附件定制</Button>}*/}
                                </Panel>;
                            })
                        }
                    </Collapse>
                </div>
            </TabPane>
        </Tabs>;
        const imgArea = () => <div className="main-left">
            <img src={detailData.bigImg ? config.server + (detailData.bigImg) : zanWu}
                 className="max-img"
                 alt='图片加载失败'/>
            {!this.inIframe && <div className="img-list">
                {
                    (detailData.picUrls || []).map((qst, key) => {
                        return <div className={key == selectImgIndex ? 'selected-img' : ''} key={key}
                                    onMouseEnter={this.updateBigImg.bind(this, key, qst)}>
                            <img
                                src={config.server + qst.fileCompressPath}
                                alt='图片加载失败'/>
                        </div>;
                    })
                }
            </div>}
        </div>;
        const modalArea = () => <Modal {...modalProps}>
            {(opt !== 'goAway') && <p>
                购买数量：
                <InputNumber
                    size="large"
                    style={{width: '120px'}}
                    min={1}
                    max={10}
                    step={detailData.minPackageFlag === 'Y' && detailData.minPackageQuantity ? detailData.minPackageQuantity : 1}
                    value={detailData.count}
                    onChange={val => this.setState({detailData: {...detailData, count: val}})}/>
            </p>}
            {(opt === 'goAway') && <p>{customOrderInfo}</p>}
        </Modal>;
        // 产品详情-价格
        const productInfoArea = () =>
            <div className="main-right detail_field select-product">
                <Row gutter={2}>
                    <Col span={6}>
                        <img src={detailData.bigImg ? config.server + (detailData.bigImg) : zanWu}
                             className="max-img"
                             alt='图片加载失败'/>
                    </Col>
                    <Col span={18}>
                        <div className="detail-top">
                            {
                                !!(mchDetail.seriesName) &&
                                <div className="detail-top-series">{mchDetail.seriesName}</div>
                            }
                            {
                                !!(detailData.stockType) &&
                                <div className="detail-top-stock">{detailData.stockType}</div>
                            }
                        </div>
                        {/* <div className="pro-title clear">
              {!!this.inIframe && <Tooltip title={detailData.name}>
                <span className="title-main inIframe">{detailData.name}</span>
              </Tooltip>}
              {!this.inIframe && <span className="title-main">{detailData.name}</span>}
            </div> */}
                        <div className="detail-info-name">
                            <Tooltip title={detailData.name}>
                                <span>{detailData.name}</span>
                            </Tooltip>
                        </div>
                        <div className="detail-info-unit">
                            单位：{detailData.unit}
                        </div>
                        <div className="detail-info-price">
                            <label className="info-name">牌价：<span className="price-unit">¥</span></label>
                            <span className="price-val">{returnFloat(!!detailData.id ? priceStock.price : 0, '')}</span>
                        </div>
                        {/* <div className="price">
              <div className="price-left">
                <span> 牌价：{returnFloat(!!detailData.id ? priceStock.price : 0)}</span>
              </div>
              {!!detailData.id && <div className="price-right">
                <p>&emsp;</p>
                <p>
                  <span>浏览量</span>
                  <span>{detailData.viewCount}</span>
                </p>
              </div>}
            </div> */}
                    </Col>
                </Row>

                <div className="de">
                    <ul className="left">
                        <li>
                            <label>物料编码</label>
                            <p>{detailData.itemNum}</p>
                        </li>
                        {/* <li>
              <label>单位</label>
              <p>{detailData.unit}</p>
            </li> */}
                        {!this.inIframe && <li>
                            <label>最小装箱数</label>
                            <p>{detailData.minPackageQuantity}</p>
                        </li>}
                        <li>
                            <label>装箱数</label>
                            <p>{detailData.packageQuantity}</p>
                        </li>
                        {/* {!this.inIframe && <li>
              <label>每小盒数量</label>
              <p>{detailData.sortOrder}</p>
            </li>} */}
                        <li>
                            <label>购买数量</label>
                            <p>
                                <InputNumber
                                    style={{width: '80px'}}
                                    min={1}
                                    max={10}
                                    step={detailData.minPackageFlag === 'Y' && detailData.minPackageQuantity ? detailData.minPackageQuantity : 1}
                                    value={detailData.count}
                                    onChange={val => this.setState({detailData: {...detailData, count: val}})}/>&nbsp;件
                            </p>
                        </li>
                    </ul>
                    {/* <ul className="right">
            <li>
              <label>物料大类</label>
              <p>{detailData.proBigName}</p>
            </li>
            <li>
              <label>库存类型</label>
              <p>{detailData.stockType}</p>
            </li>
            {!this.inIframe && <li>
              <label>最小起订量</label>
              <p>{detailData.minOrderQuantity}</p>
            </li>}
            <li>
              <label>产品线</label>
              <p>{productLineName[detailData.proLine]}</p>
            </li>
          </ul> */}
                </div>
                {/*<div className="all-button"></div>*/}
                <div className="product-detail-btns">
                    {this.inIframe && !!detailData.id && <Row type="flex" justify="end">
                        <Button type="primary" size="large" onClick={() => this.openModal('add')}>添加商品</Button>
                    </Row>}
                    {/*{!detailData.id && <Row type="flex" justify="end">*/}
                    {/*    <Button size="large"*/}
                    {/*            onClick={() => this.openModal('goAway', detailData.session_key)}>产品定制</Button>*/}
                    {/*</Row>}*/}
                    {!this.inIframe && !!detailData.id && <Row type="flex" justify="end">
                        <Button type="primary" size="large" style={{width: '140px'}}
                                onClick={() => this.openModal('addCart')}>加入购物车</Button>
                        &emsp;&emsp;&emsp;&emsp;
                        <Button style={{width: '140px'}} type="primary" size="large"
                                onClick={() => this.openModal('buy')}>立即购买</Button>
                    </Row>}
                </div>
            </div>;

        // 暂无数据
        const nullData = (text = '暂无产品参数') =>
            <div style={{
                width: '100%',
                height: '400px',
                textAlign: 'center',
                position: 'relative',
            }}>
                <img style={{
                    width: '200px',
                    height: '200px',
                    position: 'absolute',
                    top: '28px',
                    left: '50%',
                    marginLeft: '-100px',
                }} src={require('../../assets/images/null.png')} alt=""/>
                <p style={{
                    width: '100%',
                    height: '274px',
                    paddingTop: '250px',
                    textAlign: 'center',
                    lineHeight: '24px',
                    fontSize: '18px',
                    color: '#999',
                }}>{text}</p>
            </div>;

        // 产品详情所有信息
        const productInfoAll = (style) =>
            <Tabs defaultActiveKey="1" className="product-detail-tabs" onChange={this.onChangeDetailTab}>
                <TabPane tab="产品价格" key="1" style={style} className="mall-scrollbar">
                    {productInfoArea()}
                </TabPane>
                <TabPane tab="产品概述" key="2" style={style} className="mall-scrollbar">
                    <ul className="detail-info-files">
                        {
                            !!(mchDetail.commodityList) ?
                                mchDetail.commodityList.map(item =>
                                    (
                                        <li key={item.id}>
                                            <Row gutter={2}>
                                                <Col span={3}>{item.extension}</Col>
                                                <Col span={15} className="file-name">{item.fileName}</Col>
                                                <Col span={6} className="product-detail-btns">
                                                    <button onClick={this.onOpenFile.bind(this, 'look', item)}>查看
                                                    </button>
                                                    {/* className="btn-download"  */}
                                                    <button
                                                        onClick={this.onOpenFile.bind(this, 'download', item)}>下载
                                                    </button>
                                                </Col>
                                            </Row>
                                        </li>
                                    )
                                ) : ''
                        }
                        {
                            (mchDetail.dmsCommonAttachFileExternalList != null) ?
                                mchDetail.dmsCommonAttachFileExternalList.map(itm => {
                                    if (itm.fileType == 'sample' || itm.fileType == 'InstructionManual' || itm.fileType == 'specification')
                                        return (<li key={itm.id}>
                                            <Row gutter={2}>
                                                <Col span={3}>{itm.extension}</Col>
                                                <Col span={15} className="file-name">{itm.fileName}</Col>
                                                <Col span={6} className="product-detail-btns">
                                                    <button
                                                        onClick={this.downloadFileExt.bind(this, itm.filePath)}>下载
                                                    </button>
                                                </Col>
                                            </Row>
                                        </li>)
                                }) : ''
                        }
                    </ul>
                    {
                        !!(defProductDetail.graphicDetails || mchDetail.imageTextDetail) ?
                            <div className="info-img-content">
                                <div
                                    dangerouslySetInnerHTML={{__html: defProductDetail.graphicDetails || mchDetail.imageTextDetail}}></div>
                            </div>
                            : nullData()
                    }
                </TabPane>
                <TabPane tab="技术参数" key="3" style={style} className="mall-scrollbar">
                    {
                        !!(defProductDetail.parameter || mchDetail.commodityParameters) ?
                            <div className="info-img-content">
                                <div
                                    dangerouslySetInnerHTML={{__html: defProductDetail.parameter || mchDetail.commodityParameters}}></div>
                            </div>
                            : nullData()
                    }
                </TabPane>
                <TabPane tab="安装尺寸" key="4" className="mall-scrollbar">
                    {
                        !!(mchDetail.mountingDimension) ?
                            <div className="info-img-content">
                                <div dangerouslySetInnerHTML={{__html: mchDetail.mountingDimension}}></div>
                            </div>
                            : nullData()
                    }
                </TabPane>
                <TabPane tab="检测报告" key="5" className="mall-scrollbar">
                    <ul className="detail-info-files">
                        {
                            !!(mchDetail.examiningReportList) ?
                                mchDetail.examiningReportList.map(item =>
                                    (
                                        <li key={item.id}>
                                            <Row gutter={2}>
                                                <Col span={3}>{item.extension}</Col>
                                                <Col span={15} className="file-name">{item.fileName}</Col>
                                                <Col span={6} className="product-detail-btns">
                                                    <button onClick={this.onOpenFile.bind(this, 'look', item)}>查看
                                                    </button>
                                                    {/* className="btn-download"  */}
                                                    <button
                                                        onClick={this.onOpenFile.bind(this, 'download', item)}>下载
                                                    </button>
                                                </Col>
                                            </Row>
                                        </li>
                                    )
                                ) : ''

                        }
                        {
                            (mchDetail.dmsCommonAttachFileExternalList != null) ?
                                mchDetail.dmsCommonAttachFileExternalList.map(itm => {
                                    if (itm.fileType == 'InspectionReport') {
                                        return (<li key={itm.id}>
                                            <Row gutter={2}>
                                                <Col span={3}>{itm.extension}</Col>
                                                <Col span={15} className="file-name">{itm.fileName}</Col>
                                                <Col span={6} className="product-detail-btns">
                                                    <button
                                                        onClick={this.downloadFileExt.bind(this, itm.filePath)}>下载
                                                    </button>
                                                </Col>
                                            </Row>
                                        </li>)
                                    }
                                }) : ''
                        }
                    </ul>
                </TabPane>
                <TabPane tab="认证证书" key="6" className="mall-scrollbar">
                    <ul className="detail-info-files">
                        {
                            !!(mchDetail.certificateList) ?
                                mchDetail.certificateList.map(item =>
                                    (
                                        <li key={item.id}>
                                            <Row gutter={2}>
                                                <Col span={3}>{item.extension}</Col>
                                                <Col span={15} className="file-name">{item.fileName}</Col>
                                                <Col span={6} className="product-detail-btns">
                                                    <button onClick={this.onOpenFile.bind(this, 'look', item)}>查看
                                                    </button>
                                                    {/* className="btn-download" */}
                                                    <button
                                                        onClick={this.onOpenFile.bind(this, 'download', item)}>下载
                                                    </button>
                                                </Col>
                                            </Row>
                                        </li>
                                    )
                                ) : ''
                        }
                        {
                            (mchDetail.dmsCommonAttachFileExternalList != null) ?
                                mchDetail.dmsCommonAttachFileExternalList.map(itm => {
                                    if (itm.fileType == 'certificate') {
                                        return (<li key={itm.id}>
                                            <Row gutter={2}>
                                                <Col span={3}>{itm.extension}</Col>
                                                <Col span={15} className="file-name">{itm.fileName}</Col>
                                                <Col span={6} className="product-detail-btns">
                                                    <button
                                                        onClick={this.downloadFileExt.bind(this, itm.filePath)}>下载
                                                    </button>
                                                </Col>
                                            </Row>
                                        </li>)
                                    }
                                }) : ''
                        }
                    </ul>
                </TabPane>
            </Tabs>;

        // 查看附件
        const lookFileModal = () => <Modal
            title="查看"
            visible={this.state.lookFileVisible}
            onCancel={this.handleCancelLook}
            width={'600px'}
            footer={[
                <Button key="back" size="large" onClick={this.handleCancelLook}>关闭</Button>,
            ]}
        >
            <img style={{maxHeight: '500px', maxWidth: '500px'}} src={this.state.lookFileUrl}></img>
        </Modal>;

        // 弹窗
        if (this.inIframe) {
            return <div className="select-product-iframe">
                <Row>
                    <Col span={9}>
                        <div className="detail_other" style={{borderRight: '2px solid #e1e6ea', borderTop: 'none'}}>
                            {specToggleArea()}
                        </div>
                    </Col>
                    {/* height: boxHeight - 41 */}
                    <Col span={15} className="mall-scrollbar">
                        <div className="product-detail-info">
                            {productInfoAll()}
                            {/* <div className="detail-main inIframe"> */}
                            {/* {imgArea()} */}
                            {/* {productInfoArea()}
                  </div>
              */}
                        </div>
                    </Col>
                </Row>
                {modalArea()}
                {/* 查看附件 */}
                {lookFileModal()}
            </div>;
        } else { // 页面
            return <div className={'product-content'}>
                <div className="content-top">
                    <div className="detail-main" style={{border: '1px solid #e1e6ea', borderRadius: '2px'}}>
                        {/* {imgArea()} */}
                        <div className="detail_other"
                             style={{width: '40%', borderRight: '2px solid #e1e6ea', borderTop: 'none'}}>
                            {specToggleArea()}
                        </div>
                        <div className="product-detail-info" style={{width: '60%'}}>
                            {productInfoAll({height: boxHeight - 41})}
                        </div>
                        {/* {productInfoArea()} */}
                    </div>
                </div>
                {/* <div className="detail_other">
          {specToggleArea()}
        </div> */}
                {modalArea()}
                {/* 查看附件 */}
                {lookFileModal()}
            </div>;
        }
    }
}
;
export default ProductDetail;



// WEBPACK FOOTER //
// ./src/mall/mallDetail/selectProduct.js